import { action, computed } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import reject from "lodash-es/reject"
import styles from "./help-menu.module.css"
interface Args {
  onRight: string
  attachmentPlacement: string
}

export default class HelpMenu extends Component<Args> {
  readonly styles = styles

  @tracked isHovering = true
  @tracked canShowButton = false

  @service socket
  @service socketSubscriber

  helpMenuConstraints = [
    {
      to: "window",
      attachment: "together",
      pin: true,
    },
  ]

  @computed("socket.recentlyPublishedActions.@each.id")
  get recentlyPublishedActionsWithTitles() {
    return reject(this.socket.recentlyPublishedActions, (action) => {
      return action.attributes.sync.isUserFacing !== true
    })
  }

  @computed("onRight")
  get tetherTargetId() {
    return this.args.onRight ? "tether-on-right" : "tether-on-left"
  }

  @action onMouseEnter() {
    this.isHovering = true
  }

  @action onMouseLeave() {
    this.isHovering = false
  }
}

// TODO help menu inside with different tether outside
